export const UPDATE_SIZE_GUIDE_CONVERSION = 'UPDATE_SIZE_GUIDE_CONVERSION';
export const UPDATE_SIZE_GUIDE_MEASUREMENT_UNIT = 'UPDATE_SIZE_GUIDE_MEASUREMENT_UNIT';
export const GET_AVAILABLE_SIZE_GUIDE_MEASUREMENT_UNITS = 'GET_AVAILABLE_SIZE_GUIDE_MEASUREMENT_UNITS';
export const UPDATE_SIZE_GUIDE_FIT = 'UPDATE_SIZE_GUIDE_FIT';
export const SAVE_SIZE_GUIDE = 'SAVE_SIZE_GUIDE';

export function getAvailableMeasurementUnits(hasInches, hasCentimeters) {

    return {
        type: GET_AVAILABLE_SIZE_GUIDE_MEASUREMENT_UNITS,
        payload: {
            hasInches: hasInches,
            hasCentimeters: hasCentimeters
        }
    };
}

export function updateSizeGuideConversion(selectedConversion) {

    return {
        type: UPDATE_SIZE_GUIDE_CONVERSION,
        payload: {
            selectedConversion: selectedConversion
        }
    };
}

export function updateSizeGuideMeasurementUnit(selectedUnit) {

    return {
        type: UPDATE_SIZE_GUIDE_MEASUREMENT_UNIT,
        payload: selectedUnit
    };
}

export function updateSizeGuideFit(selectedFit) {

    return {
        type: UPDATE_SIZE_GUIDE_FIT,
        payload: {
            selectedFit: selectedFit
        }
    };
}

export function saveSizeGuide(sizeGuide) {

    return {
        type: SAVE_SIZE_GUIDE,
        payload: {
            sizeGuide: sizeGuide
        }
    };
}
